<!-- 
<div fxLayout.xs="row" fxLayoutGap="10px" fxLayoutAlign="center">

</div>
<br> -->

<div class="message-container">
    <app-response-text [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>
</div>
<br>

<div fxLayout="row" fxLayoutAlign="center">
    <app-mat-data-grid 
        class="page-data-grid" 
        [formValid]="formValid" 
        [(dataSource)]="config_filteredData"
        [displayedColumns]="['Username', 'Extension']" 
        [header]="header" 
        [columnNames]="['Username', 'Extension']"
        [editDefinition]="{'Extension': extensionTemplate}" 
        [pageSizeOptions]="[10, 30, 50]" 
        [buttonConfig]="{
            delete: {enabled: false}
        }"
        (buttonClick)="config_handleItemChange($event); syncDisabled = ($event.button === 'edit'); lambdaError = false; lambdaMessage = '';">
    </app-mat-data-grid>
</div>

<a id="downloadLink" hidden></a>

<!-- header -->
<ng-template #header>
    <button mat-raised-button color="primary" class="spaced-button" [disabled]="downloadDisabled" (click)="buildCSV();">Download CSV</button>
    <span fxLayout="row" fxLayoutAlign="center">
        empty extension:
        <app-toggle-switch id="switch" class="lefty" [(switch)]="blankOnly" (switchChange)="applyFilter(filterString);"></app-toggle-switch>
    </span>
</ng-template>

<!-- extension -->
<ng-template #extensionTemplate let-element>
    <input type="text" [(ngModel)]="element.Extension" (ngModelChange)="formValid = config_validate(element);">
</ng-template>